export const SET_NEW_TOKEN = "SET_NEW_TOKEN";

export const setNewToken = (data) => ({
  type: SET_NEW_TOKEN,
  data: data,
});
